import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { C, DISP, BODY, track, scrollToId } from './shared';

const LINKS = [
  { label: 'Product', to: '#outcomes' },
  { label: 'How it works', to: '#how-it-works' },
  { label: 'Use cases', to: '/marketing-for-founders' },
  { label: 'Pricing', to: '#pricing' },
];

export const LandingNav = () => {
  const navigate = useNavigate();
  const [solid, setSolid] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const on = () => setSolid(window.scrollY > 60);
    window.addEventListener('scroll', on, { passive: true });
    return () => window.removeEventListener('scroll', on);
  }, []);

  useEffect(() => {
    document.body.style.overflow = open ? 'hidden' : '';
    return () => { document.body.style.overflow = ''; };
  }, [open]);

  const go = (to) => {
    setOpen(false);
    if (to.startsWith('#')) scrollToId(to.slice(1));
    else navigate(to);
  };

  const linkStyle = { fontFamily: BODY, fontSize: 14, fontWeight: 500, color: C.body, transition: 'color 0.2s' };

  return (
    <>
      <nav aria-label="Main navigation" style={{
        position: 'fixed', top: 0, left: 0, right: 0, zIndex: 60,
        height: 64, display: 'flex', alignItems: 'center',
        padding: '0 clamp(20px, 4vw, 48px)',
        background: (solid || open) ? 'rgba(5,7,10,0.94)' : 'transparent',
        backdropFilter: (solid || open) ? 'blur(20px)' : 'none',
        WebkitBackdropFilter: (solid || open) ? 'blur(20px)' : 'none',
        borderBottom: solid ? `1px solid ${C.border}` : '1px solid transparent',
        transition: 'background 0.25s, border-color 0.25s',
      }}>
        <Link to="/" data-testid="nav-logo" style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
          <div style={{ width: 30, height: 30, borderRadius: 8, background: C.lime, color: C.bg, display: 'grid', placeItems: 'center', fontFamily: DISP, fontWeight: 800, fontSize: 15 }}>S</div>
          <span style={{ fontFamily: DISP, fontWeight: 800, fontSize: 16, color: C.text }}>ScalitOS</span>
        </Link>

        <div className="scl-nav-desktop" style={{ gap: 30, marginLeft: 48, marginRight: 'auto', alignItems: 'center' }}>
          {LINKS.map((l) => (
            <button key={l.label} onClick={() => go(l.to)} data-testid={`nav-link-${l.label.toLowerCase().replace(/\s/g, '-')}`}
              style={linkStyle}
              onMouseEnter={(e) => { e.currentTarget.style.color = C.lime; }}
              onMouseLeave={(e) => { e.currentTarget.style.color = C.body; }}>
              {l.label}
            </button>
          ))}
          <Link to="/blog" data-testid="nav-blog" style={linkStyle}
            onMouseEnter={(e) => { e.currentTarget.style.color = C.lime; }}
            onMouseLeave={(e) => { e.currentTarget.style.color = C.body; }}>Blog</Link>
        </div>

        <div style={{ display: 'flex', alignItems: 'center', gap: 12, marginLeft: 'auto' }}>
          <button onClick={() => navigate('/login')} data-testid="nav-login-btn"
            className="scl-nav-desktop"
            style={{ fontFamily: BODY, fontSize: 14, fontWeight: 500, color: C.body }}>Sign in</button>
          <button onClick={() => { track('nav_cta_clicked'); navigate('/register'); }} data-testid="nav-cta"
            style={{ background: C.lime, color: C.bg, padding: '10px 18px', borderRadius: 10, fontFamily: BODY, fontSize: 14, fontWeight: 700, transition: 'background 0.2s' }}
            onMouseEnter={(e) => { e.currentTarget.style.background = C.limeHover; }}
            onMouseLeave={(e) => { e.currentTarget.style.background = C.lime; }}>
            Start free
          </button>
          <button className="scl-nav-burger" onClick={() => setOpen(!open)} data-testid="nav-mobile-toggle"
            aria-expanded={open} aria-label={open ? 'Close menu' : 'Open menu'}
            style={{ width: 44, height: 44, alignItems: 'center', justifyContent: 'center', borderRadius: 10, border: `1px solid ${C.border}` }}>
            <svg width="18" height="14" viewBox="0 0 18 14" fill="none" stroke={C.text} strokeWidth="2" strokeLinecap="round">
              {open ? <><path d="M2 2l14 10" /><path d="M16 2L2 12" /></> : <><path d="M1 1h16" /><path d="M1 7h16" /><path d="M1 13h16" /></>}
            </svg>
          </button>
        </div>
      </nav>

      {open && (
        <div data-testid="nav-mobile-menu" style={{ position: 'fixed', inset: 0, top: 64, zIndex: 55, background: 'rgba(5,7,10,0.98)', padding: '32px 24px', display: 'flex', flexDirection: 'column', gap: 6 }}>
          {LINKS.map((l) => (
            <button key={l.label} onClick={() => go(l.to)}
              style={{ textAlign: 'left', padding: '16px 8px', borderBottom: `1px solid ${C.border}`, fontFamily: DISP, fontWeight: 700, fontSize: 22, color: C.text }}>
              {l.label}
            </button>
          ))}
          <button onClick={() => go('/blog')} style={{ textAlign: 'left', padding: '16px 8px', borderBottom: `1px solid ${C.border}`, fontFamily: DISP, fontWeight: 700, fontSize: 22, color: C.text }}>Blog</button>
          <div style={{ marginTop: 28, display: 'flex', flexDirection: 'column', gap: 12 }}>
            <button onClick={() => go('/register')} className="scl-btn-primary" data-testid="nav-mobile-cta">Start free →</button>
            <button onClick={() => go('/login')} className="scl-btn-ghost">Sign in</button>
          </div>
        </div>
      )}
    </>
  );
};
